var exports = {
  "kL": "CreateDMBottomSheet.module__container___dmF2eT",
  "XG": "CreateDMBottomSheet.module__scroller___dmF2eT",
  "Qs": "CreateDMBottomSheet.module__content___dmF2eT",
  "h_": "CreateDMBottomSheet.module__description___dmF2eT",
  "ov": "CreateDMBottomSheet.module__friendSelector___dmF2eT",
  "qr": "CreateDMBottomSheet.module__footer___dmF2eT",
  "x7": "CreateDMBottomSheet.module__cancelButton___dmF2eT",
  "Tf": "CreateDMBottomSheet.module__createButton___dmF2eT",
};

module.exports = exports;
